export default __webpack_public_path__ + "../img/6fac3991f899aea24178f4816e3dce61.png";